$(function() {

  $(document).on('click', '#q_deleted', function(event) {
    $(this).closest('form').submit();
  });

});
